export enum ReturnExchangedSystem {
	None = 0,
	TroqueCommerce = 1,
}
